/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://api.euro-drive.co.il/swagger/v1/swagger.json **/

import axios from "../axios"
import * as Eurodrive from "./EurodriveInterfaces"

export const postBranchesImport = (
  data: Eurodrive.ImportBranchesRequest[],
  locale?: string,
) =>
  axios.post<Eurodrive.ImportingDataBaseResponseResponseWrapper>(
    `/api/branches/import`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getBranches = (locale?: string) =>
  axios.get<Eurodrive.BranchDtoListResponseWrapper>(`/api/branches`, {
    headers: { "X-Accept-Language": locale },
  })

export const postCareerJobApplication = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
  locale?: string,
) =>
  axios.post<Eurodrive.BooleanResponseWrapper>(
    `/api/career/jobApplication`,
    formData,
    {
      onUploadProgress,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Accept-Language": locale,
      },
    },
  )

export const getCarsImportingUmbracoFetchLeasing = (locale?: string) =>
  axios.get<Eurodrive.LeasingCarForUmbracoDto[]>(
    `/api/cars-importing/umbraco/fetchLeasing`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCarsImportingUmbracoFetchSale = (locale?: string) =>
  axios.get<Eurodrive.SaleCarForUmbracoDto[]>(
    `/api/cars-importing/umbraco/fetchSale`,
    { headers: { "X-Accept-Language": locale } },
  )

export const postCarsImportingLeasing = (
  data: Eurodrive.ImportLeasingCarsRequest,
  locale?: string,
) =>
  axios.post<Eurodrive.ImportingDataBaseResponseResponseWrapper>(
    `/api/cars-importing/leasing`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postCarsImportingSale = (
  data: Eurodrive.ImportSaleCarsRequest,
  locale?: string,
) =>
  axios.post<Eurodrive.ImportingDataBaseResponseResponseWrapper>(
    `/api/cars-importing/sale`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postCarsImportingMasterManufacturer = (
  data: Eurodrive.ImportMasterManufacturerRequest,
  locale?: string,
) =>
  axios.post<Eurodrive.ImportingDataBaseResponseResponseWrapper>(
    `/api/cars-importing/master-manufacturer`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCarsSearchMetadataTypeClassification = (
  type: string,
  classification: string,
  locale?: string,
) =>
  axios.get<Eurodrive.SearchMetadataResponseResponseWrapper>(
    `/api/cars-search/metadata/${type}/${classification}`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCarsSearchMetadataType = (type: string, locale?: string) =>
  axios.get<Eurodrive.GroupedSearchMetadataResponseResponseWrapper>(
    `/api/cars-search/metadata/${type}`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCarsSearchSaleVehicleNumber = (
  vehicleNumber: string,
  locale?: string,
) =>
  axios.get<Eurodrive.SaleCarDtoResponseWrapper>(
    `/api/cars-search/sale/${vehicleNumber}`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCarsSearchLeasingManufacturerManufacturerCodeModelModelCode = (
  manufacturerCode: string,
  modelCode: string,
  locale?: string,
) =>
  axios.get<Eurodrive.LeasingCarDtoResponseWrapper>(
    `/api/cars-search/leasing/manufacturer/${manufacturerCode}/model/${modelCode}`,
    { headers: { "X-Accept-Language": locale } },
  )

export const postCarsSearchSearchLeasing = (
  data: Eurodrive.SearchCarsRequest,
  locale?: string,
) =>
  axios.post<Eurodrive.LeasingCarDtoPaginatedListResponseWrapper>(
    `/api/cars-search/search/leasing`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postCarsSearchSearchSale = (
  data: Eurodrive.SearchCarsRequest,
  locale?: string,
) =>
  axios.post<Eurodrive.SaleCarDtoPaginatedListResponseWrapper>(
    `/api/cars-search/search/sale`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCarsSearchColorsMasterManufacturerCodeMasterModelCode = (
  masterManufacturerCode: string,
  masterModelCode: string,
  locale?: string,
) =>
  axios.get<Eurodrive.MasterManufacturerColorsResponseResponseWrapper>(
    `/api/cars-search/colors/${masterManufacturerCode}/${masterModelCode}`,
    { headers: { "X-Accept-Language": locale } },
  )

export const postContactUsLead = (
  data: Eurodrive.CreateLeadRequest,
  locale?: string,
) =>
  axios.post<Eurodrive.CreateLeadResponseResponseWrapper>(
    `/api/contactUs/lead`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getSettingsAll = (locale?: string) =>
  axios.get<Eurodrive.GeneralSettingResponseListResponseWrapper>(
    `/api/settings/all`,
    { headers: { "X-Accept-Language": locale } },
  )
